
export default {
  name: 'AppCard',
  props: {
    extendable: { type: Boolean, default: false },
    isExtending: { type: Boolean, default: false }
  }
};
